export const EVENT_TOPICS = [
  "Нетворкинг и общение",
  "Бизнес и предпринимательство",
  "Социальное и благотворительность",
  "Спорт и активный отдых",
  "Здоровье и wellness",
  "Психология и саморазвитие",
  "Эзотерика и духовные практики",
  "Дети и семья",
  "Творчество и хобби",
  "Языки и обучение",
  "Культура и искусство",
  "Экскурсии и путешествия",
  "Еда и гастрономия",
  "Вечеринки и развлечения",
] as const;

export type EventTopic = (typeof EVENT_TOPICS)[number];

/** Оставляет только известные темы, сохраняя канонический порядок списка. */
export function normalizeTopics(input: unknown): string[] {
  const arr = Array.isArray(input) ? (input as unknown[]).map(String) : [];
  const set = new Set(arr);
  return EVENT_TOPICS.filter((t) => set.has(t));
}
